import React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgBasket = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M14.875 13.125v6.125a.875.875 0 1 1-1.75 0v-6.125a.875.875 0 1 1 1.75 0Zm4.03-.088-.613 6.126a.876.876 0 0 0 .783.962.66.66 0 0 0 .089 0 .876.876 0 0 0 .87-.788l.612-6.124a.875.875 0 1 0-1.742-.175Zm-9.81 0a.875.875 0 0 0-1.74.175l.612 6.125a.875.875 0 0 0 .875.788c.03.002.059.002.088 0a.875.875 0 0 0 .784-.958l-.618-6.13Zm17.147-3.296-1.648 12.366a1.757 1.757 0 0 1-1.735 1.518H5.141a1.757 1.757 0 0 1-1.735-1.518L1.758 9.74a.875.875 0 0 1 .867-.991h4.853l5.866-6.701a.876.876 0 0 1 1.312 0l5.866 6.701h4.853a.875.875 0 0 1 .867.99ZM9.803 8.75h8.394L14 3.954 9.803 8.75Zm14.572 1.75H3.625L5.14 21.875h17.718L24.375 10.5Z" />
  </svg>
);
export default SvgBasket;
